import React from "react";
import {AppProvider} from "./app_context";

const RootElement = ({children}) => {
  return <AppProvider>{children}</AppProvider>;
}

export default RootElement;